module.exports = __webpack_public_path__ + "img/logo-main.840cd174.png";